import moment from "moment";

export const ordersRules = {
    shouldSelectAtLeastOneOrder: (selectedList, swalInstance) => {
      if (selectedList.length === 0) {
        swalInstance({
          title: "Bir Sipariş Seçin",
          text: "Lütfen en az bir sipariş seçerek devam edin. planlanmayanlar sekmesinden siparişleri işaretleyerek tekrar deneyin.",
          icon: "warning",
          confirmButtonText: "Tamam, Seçim Yap",
          showCancelButton: true,
          cancelButtonText: "İptal",
        });
        return false;
      }
      return true;
    },
  
    shouldNotExceedMaxOrderLimit: (selectedList, swalInstance, max = 15) => {
      if (selectedList.length == max) {
        swalInstance({
          title: "Sınırlama Aşıldı",
          text: `En fazla ${max} sipariş seçebilirsiniz. Daha fazla sipariş eklemek isterseniz, mevcut seçimlerinizi gözden geçirebilirsiniz.`,
          icon: "warning",
          confirmButtonText: "Tamam, Gözden Geçir",
          showCancelButton: true,
          cancelButtonText: "İptal",
        });
        return false;
      }
      return true;
    },


    hasDriverInfoIssues: (selectedList,swalInstance) => {
      const invalidItems = selectedList.filter(
        (item) =>
          !(item.driver && item.driverTC) && // Sürücü ve TC bilgisi eksik
          !item.isPirateDriver && // Korsan sürücü değilse kontrol et
          (item.unitType === "TON" ? item.tonnage <= 30 : item.tonnage === 1) // Küçük sipariş
      );
  
      if (invalidItems.length) {
        const vehicles = invalidItems.map((item) => item.vehicleName).join(", ");
  
        swalInstance({
          title: "Uyarı!",
          text: `Planlama yapılamaz. Aşağıdaki ${
            invalidItems.length > 1 ? "araçlar" : "araç"
          } için sürücü bilgisi veya TC kimlik bilgisi eksik: ${vehicles} plakalı ${
            invalidItems.length > 1 ? "araçlara" : "araca"
          } lütfen sürücü atayınız veya mevcut sürücünün TC kimlik bilgisini giriniz.`,
          icon: "warning",
        });
  
        return false;
      }
  
      return true;
    } ,

    hasValidSRC5: (item, driver, products,swalInstance) => {
      const product = products.find((p) => p.id == item.productId);
      const isProductRequireSrc = product?.typeId == 2;
  
      if (!isProductRequireSrc) return true;
  
      let warningMessage = [];
  
      if (!driver?.srcEndTime) {
        warningMessage.push("Sürücünün SRC-5 Belgesi bilgisi bulunmuyor.");
      } else {
        const now = moment();
        const deliveryDate = moment(item?.deliveryDate);
  
        if (
          moment(driver.srcEndTime).diff(now, "days") <= 0 ||
          moment(driver.srcEndTime).diff(deliveryDate, "days") <= 0
        ) {
          warningMessage.push("Sürücünün SRC-5 belgesi süresi dolmuş.");
        }
      }
  
      if (warningMessage.length > 0) {
        swalInstance({
          icon: "warning",
          title: "UYARI !",
          showConfirmButton: true,
          width: "max-content",
          html: `
            <div>
              ${warningMessage
                .map(
                  (m) =>
                    `<p style='width: max-content;  margin:auto; margin-top:4px;'>${m}</p>`
                )
                .join("")}
            </div>
          `,
        });
  
        return false;
      }
  
      return true;
    },
  };
  